// Type definition for runtime environment
declare global {
  interface Window {
    _env_?: {
      REACT_APP_BASE_API?: string;
      REACT_APP_REDIRECT_PAYMENT_URL?: string;
      REACT_APP_GOOGLE_CLIENT_ID?: string;
      REACT_APP_FACEBOOK_APP_ID?: string;
      NODE_ENV?: string;
    };
  }
}

export const Environment = {
  BASE_API: (typeof window !== "undefined" && window._env_?.REACT_APP_BASE_API) || process.env.REACT_APP_BASE_API,
  REDIRECT_PAYMENT_URL: (typeof window !== "undefined" && window._env_?.REACT_APP_REDIRECT_PAYMENT_URL) || process.env.REACT_APP_REDIRECT_PAYMENT_URL,
  GOOGLE_CLIENT_ID: String((typeof window !== "undefined" && window._env_?.REACT_APP_GOOGLE_CLIENT_ID) || process.env.REACT_APP_GOOGLE_CLIENT_ID),
  FACEBOOK_APP_ID: String((typeof window !== "undefined" && window._env_?.REACT_APP_FACEBOOK_APP_ID) || process.env.REACT_APP_FACEBOOK_APP_ID),
};
